module.exports = __webpack_public_path__ + "static/media/default-img-02.18469575.png";